import { ReactComponent as CloseIcon } from './close.svg';
import { variants } from '../variants';

import { Props } from '../Icons.types';

export const Close = ({ variant = 'primary', ...props }: Props) => <CloseIcon fill={variants[variant]} {...props} />;
